import { useState } from 'react';
import { X } from 'lucide-react';
import { AuthForm } from './auth-form';
import { ForgotPasswordForm } from './forgot-password-form';

interface AuthDialogProps {
  isOpen: boolean;
  onClose: () => void;
  defaultMode?: 'signin' | 'signup';
}

export function AuthDialog({ isOpen, onClose, defaultMode = 'signin' }: AuthDialogProps) {
  const [mode, setMode] = useState<'signin' | 'signup' | 'forgot-password'>(defaultMode);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-mercury transition-colors duration-300 dark:bg-dark-card dark:shadow-mercury-dark">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-dark-text">
            {mode === 'signin' && 'Sign In'}
            {mode === 'signup' && 'Create Account'}
            {mode === 'forgot-password' && 'Reset Password'}
          </h2>
          <button 
            onClick={onClose} 
            className="text-gray-500 hover:text-gray-700 dark:text-dark-muted dark:hover:text-dark-text"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="mt-4">
          {mode === 'forgot-password' ? (
            <ForgotPasswordForm onBack={() => setMode('signin')} />
          ) : (
            <>
              <AuthForm
                mode={mode === 'signin' ? 'signin' : 'signup'}
                onSuccess={onClose}
                onForgotPassword={() => setMode('forgot-password')}
              />
              <div className="mt-4 text-center text-sm">
                {mode === 'signin' ? (
                  <p className="text-gray-600 dark:text-dark-muted">
                    Don't have an account?{' '}
                    <button
                      onClick={() => setMode('signup')}
                      className="text-primary-600 hover:text-primary-500 dark:text-primary-400 dark:hover:text-primary-300"
                    >
                      Sign up
                    </button>
                  </p>
                ) : (
                  <p className="text-gray-600 dark:text-dark-muted">
                    Already have an account?{' '}
                    <button
                      onClick={() => setMode('signin')}
                      className="text-primary-600 hover:text-primary-500 dark:text-primary-400 dark:hover:text-primary-300"
                    >
                      Sign in
                    </button>
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}